import styled from "styled-components";
import colours from "styles/colours";

export const FullWidthContainer = styled.div`
  background-color: ${colours.lightGrey};
  padding-bottom: 0.1em;
  margin-bottom: 1em;
`;
